// src/app/shared/services/media-upload.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './lsg.api.service';

@Injectable({
  providedIn: 'root',
})
export class MediaUploadService {
  constructor(private http: HttpClient, private api: ApiService) {}

  /** Convert base64 string to File */
  base64ToFile(base64: string, fileName: string): File {
    const arr = base64.split(',');
    const mime = arr[0]?.match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  }

  /** Upload a file to the backend */
  uploadFile(file: File, category: string = 'any'): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('files', file);

    const uploadPath = `sales-funnel/media/${category}`;
    return this.http.post(`${this.api.apiUrl}/${uploadPath}`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }
}
